const wrapperCls = "c2lweggj6g";
const buttonsContainerCls = "c2lbwypnf3";
const buttonContentCls = "c2lb1c14oh1";

export { buttonContentCls, buttonsContainerCls, wrapperCls };
import "./content.style.linaria.module.css";
//# sourceMappingURL=content.style.js.map
